import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { AppProviders } from "@/app/providers/AppProviders";
import { router } from "@/app/router";
import { bootPlatform } from "@/platform/boot";
import { bootstrapTextScale } from "@/shared/preferences/textScale";
import { bootstrapTextWeight } from "@/shared/preferences/textWeight";
import { setupInputAutoSelect } from "@/shared/ui/core/inputAutoSelect";
import "@/styles/fonts";
import "@/styles/globals.css";

async function start(): Promise<void> {
  try {
    await bootPlatform();
  } catch (err) {
    console.warn("Platform boot failed", err);
  }
  bootstrapTextScale();
  bootstrapTextWeight();
  setupInputAutoSelect();

  const rootEl = document.getElementById("root");
  if (!rootEl) {
    throw new Error("#root missing");
  }

  createRoot(rootEl).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}

void start();
